import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface ExtensionsTableProps {
}

export const ExtensionsTable: React.FC<ExtensionsTableProps> = () => {

    const extensionsState = useAppSelector(state => state.extensions);

    return (
        <>
            <table className="data">
                <thead>
                <tr>
                    <th>Logistik</th>
                    <th>Kehtib kuni</th>
                    <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {extensionsState.extensions.map(row => {
                    return (
                        <tr key={row.id}>
                            <td>
                                {row?.user?.firstname} {row?.user?.lastname}
                            </td>
                            <td>
                                {row.expires_at}
                            </td>
                            <td className="action">
                                <Link to={`/extensions/${row.id}/modify`}>Muuda</Link>
                                <span>|</span>
                                <Link to={`/extensions/${row.id}/delete`}>Kustuta</Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </>
    );

}